export default __webpack_public_path__ + "static/media/FavLocationYellowWeb.0145349c.svg";